import {Box, Typography} from "@mui/material";

function UXRegister() {

    return (
        <Box>
            <Typography variant="h4">Register</Typography>
        </Box>
    )
}

export default UXRegister

